import React, { useState, useEffect } from "react";
import { AuthenticationType } from "../../Types/AuthenticationType";
import MainContext from "../../_helpers/contexts/mainContext";
import { EkoBillingHeader } from "../EkoBillingHeader/EkoBillingHeader";
import { EkoBillingFooter } from "../EkoBillingFooter/EkoBillingFooter";
import { EkoBillingNavbar } from "../EkoBillingNavbar/EkoBillingNavbar";
import { Link, useLocation } from "react-router-dom";

interface LayoutInterface {
  children: React.ReactNode;
}
const LoggedInLayout: React.FC<LayoutInterface> = ({ children }) => {
  const [authentication] = useState<AuthenticationType>({
    login: localStorage.getItem("login") ?? undefined,
    token: localStorage.getItem("authorization") ?? undefined,
  });

  const path = useLocation().pathname;
  const [userLogged, setUserLogged] = useState<boolean>();

  useEffect(() => {
    if (path.indexOf("Reset") >= 1 || path === "/login") {
      setUserLogged(false);
    }
    else {
      setUserLogged(true);
    }
  }, [path]);



  return (
    <MainContext.Provider value={authentication}>
      <div className="main">
        <EkoBillingHeader />
        {userLogged ? (
          <div className="container">
            <div className="content row">
              <div className="col-3 navi">
                <EkoBillingNavbar />
              </div>
              <div className="col-9 tab">{children}</div>
            </div>
          </div>
        ) : (
          children
        )}
        <EkoBillingFooter />
      </div>
    </MainContext.Provider>
  );
};

export { LoggedInLayout };
